import script from "./list.vue?vue&type=script&setup=true&lang=ts"
export * from "./list.vue?vue&type=script&setup=true&lang=ts"

import "./list.vue?vue&type=style&index=0&id=1f87017e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f87017e"]])

export default __exports__